import React from "react";
import { Link } from "react-router-dom";
import type { Location } from "../../../../interfaces/country.interface";
import { normalizeActiveStorageUrl } from "../../../../utils/imageUrl";

const FALLBACK_IMAGE = "/iceholidays-assets/images/destination-background.png";

function listingLink(location: Location) {
  const params = new URLSearchParams({
    keyword: location.name,
    location_id: location.id.toString(),
    brands: "GD_Standard",
    type: "series",
  });

  return `/web/listing?${params.toString()}`;
}

export default function DestinationCard({ destination }: { destination: Location }) {
  return (
    <Link to={listingLink(destination)} className="v2-tag-card">
      <div className="v2-tag-card__frame">
        <div className="v2-tag-card__photo">
          <span className="v2-tag-card__img" style={{ backgroundImage: `url(${normalizeActiveStorageUrl(destination.cover, FALLBACK_IMAGE)})` }} aria-hidden="true" />
          <span className="v2-tag-card__strap" aria-hidden="true" />
          <span className="v2-tag-card__label">{destination.name}</span>
        </div>
      </div>
    </Link>
  );
}
